export enum UserStatus {
	ACTIVE = 'ACTIVE',
	PENDING_ACTIVE = 'PENDING_ACTIVE',
	LOCK = 'LOCK',
	PRE_REGISTERED = 'PRE_REGISTERED',
	DEACTIVATED = 'DEACTIVATED',
}
